module.exports = __webpack_public_path__ + "img/vertical_3_5_3016.b0ef8462.png";